const plansToSupplierForm = (plans = []) => {
  return plans.map((plan) => ({
    id: plan?.templateCompanyId,
    name: plan?.name,
  }))
}

export default plansToSupplierForm
